export default __webpack_public_path__ + "static/media/new.12a59990.svg";